import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderMenu from "./sidebar/headermenu";
import { API_STATUS } from "../constants";
import { GetSingleEvent } from "../apis/event/get_single_event";
import EventBox from "./events/event_box";
import { SaveEventView } from "../apis/event/save_event_view";
import { GetBasicEvent } from "../apis/event/get_basic_event";
import DummyMenu from "./sidebar/dummymenu";
import LoginModel from "./login/login_model";

export default function EventDetails() {
    const params = useParams({ eventId: String });
    const navigate = useNavigate();
    const [item, setItem] = useState('');
    const [eventApi, setEventApi] = useState(API_STATUS);
    const [login, setLogin] = useState(false);


    useEffect(() => {
        const token = localStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            setLogin(false);
            GetBasicEvent(params.eventId, setEventApi);
        } else {
            setLogin(true);
            GetSingleEvent(params.eventId, setEventApi);
            SaveEventView(params.eventId);
        }
    }, []);



    useEffect(() => {
        if (!eventApi.isError && !eventApi.isLoader && eventApi.data != null) {
            let res = eventApi.data;
            if (res['status'] === 1) {
                setItem(res['data']);
            }
        }
    }, [eventApi]);

    return <div id="wrapper">
        {
            login &&
            <HeaderMenu />
        }
        {
            !login &&
            <DummyMenu />
        }
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-2xl mx-auto">
                <div class="page__heading py-6 mt-6">
                    <a href="/">
                        <ion-icon name="chevron-back-outline"></ion-icon> Back
                    </a>
                    {/* <h1> Settings </h1> */}
                </div>
                <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2 mb-20">
                    {
                        item !== null && item !== "" &&
                        <EventBox item={item} detail={true} />
                    }
                </div>
            </div>
        </main>
        {
            !login &&
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#ffffffb4' }}>
                <LoginModel />
            </div>
        }
    </div>
}